import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you! We will contact you soon via WhatsApp: 0119008944');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Contact Us</h1>
      <p style={styles.subtitle}>Get in touch with GlowFlex Sisters Club</p>

      <div style={styles.content}>
        {/* Contact Info */}
        <div style={styles.infoSection}>
          <h2 style={styles.sectionTitle}>Reach Out</h2>
          
          <div style={styles.contactItem}>
            <div style={styles.icon}></div>
            <div>
              <h3 style={styles.contactLabel}>Phone / WhatsApp</h3>
              <p style={styles.contactValue}>
                <a href="https://wa.me/254119008944" target="_blank" rel="noopener noreferrer" style={{color: '#2C2C2C', textDecoration: 'none'}}>
                  0119008944
                </a>
              </p>
            </div>
          </div>

          <div style={styles.contactItem}>
            <div style={styles.icon}></div>
            <div>
              <h3 style={styles.contactLabel}>Email</h3>
              <p style={styles.contactValue}>
                <a href="mailto:glowflexsisters@gmail.com" style={{color: '#2C2C2C', textDecoration: 'none'}}>
                  glowflexsisters@gmail.com
                </a>
              </p>
            </div>
          </div>

          <div style={styles.contactItem}>
            <div style={styles.icon}></div>
            <div>
              <h3 style={styles.contactLabel}>M-Pesa Payments</h3>
              <p style={styles.contactValue}>0119008944</p>
            </div>
          </div>

          <div style={styles.contactItem}>
            <div style={styles.icon}></div>
            <div>
              <h3 style={styles.contactLabel}>Location</h3>
              <p style={styles.contactValue}>Nairobi, Kenya</p>
            </div>
          </div>

          <div style={styles.contactItem}>
            <div style={styles.icon}></div>
            <div>
              <h3 style={styles.contactLabel}>Follow Us</h3>
              <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap'}}>
                <a href="https://instagram.com/glowflex.ke" target="_blank" rel="noopener noreferrer" style={styles.socialLink}>
                   Instagram
                </a>
                <a href="https://tiktok.com/@glowflex.ke" target="_blank" rel="noopener noreferrer" style={styles.socialLink}>
                   TikTok
                </a>
                <a href="https://snapchat.com/add/glowflex.ke" target="_blank" rel="noopener noreferrer" style={styles.socialLink}>
                   Snapchat
                </a>
              </div>
            </div>
          </div>

          <div style={styles.hoursBox}>
            <h3 style={styles.hoursTitle}>Activity Hours</h3>
            <p style={styles.hoursText}>Wednesday - Friday: 5:30 PM - 7:30 PM</p>
            <p style={styles.hoursText}>Saturday - Sunday: 9:30 AM - 11:00 AM</p>
          </div>
        </div>

        {/* Contact Form */}
        <div style={styles.formSection}>
          <h2 style={styles.sectionTitle}>Send us a Message</h2>
          <form onSubmit={handleSubmit}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Name *</label>
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                style={styles.input}
                placeholder="Your name"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Email *</label>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                style={styles.input}
                placeholder="your@email.com"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Phone *</label>
              <input
                type="tel"
                required
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                style={styles.input}
                placeholder="0712345678"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Message *</label>
              <textarea
                required
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                style={styles.textarea}
                placeholder="How can we help you?"
                rows="5"
              />
            </div>

            <button type="submit" className="btn btn-primary" style={{width: '100%', padding: '1rem'}}>
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { maxWidth: '1200px', margin: '0 auto', padding: '2rem' },
  title: { fontSize: '3rem', textAlign: 'center', marginBottom: '1rem', fontFamily: 'Playfair Display, serif', color: '#1a5632' },
  subtitle: { textAlign: 'center', fontSize: '1.2rem', color: '#5A5A5A', marginBottom: '3rem' },
  content: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '3rem' },
  
  infoSection: { background: 'white', padding: '2rem', borderRadius: '20px', boxShadow: '0 4px 16px rgba(0,0,0,0.1)' },
  formSection: { background: 'white', padding: '2rem', borderRadius: '20px', boxShadow: '0 4px 16px rgba(0,0,0,0.1)' },
  
  sectionTitle: { fontSize: '1.8rem', marginBottom: '2rem', color: '#1a5632', fontFamily: 'Playfair Display, serif' },
  
  contactItem: { display: 'flex', gap: '1rem', marginBottom: '2rem', alignItems: 'flex-start' },
  icon: { fontSize: '2rem', background: '#f0f0f0', padding: '0.75rem', borderRadius: '50%', width: '3rem', height: '3rem', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  contactLabel: { fontSize: '0.9rem', color: '#888', marginBottom: '0.25rem' },
  contactValue: { fontSize: '1.1rem', fontWeight: 600, color: '#2C2C2C', margin: 0 },
  
  socialLink: { color: '#1a5632', textDecoration: 'none', fontWeight: 600, fontSize: '0.95rem', transition: 'opacity 0.3s' },
  
  hoursBox: { background: '#f0f8f0', padding: '1.5rem', borderRadius: '12px', marginTop: '2rem', border: '2px solid #7AB845' },
  hoursTitle: { fontSize: '1.2rem', color: '#1a5632', marginBottom: '0.75rem' },
  hoursText: { color: '#2C2C2C', marginBottom: '0.5rem', fontSize: '0.95rem' },
  
  formGroup: { marginBottom: '1.5rem' },
  label: { display: 'block', fontWeight: 600, marginBottom: '0.5rem', color: '#2C2C2C' },
  input: { width: '100%', padding: '0.875rem', border: '2px solid #ddd', borderRadius: '12px', fontSize: '1rem' },
  textarea: { width: '100%', padding: '0.875rem', border: '2px solid #ddd', borderRadius: '12px', fontSize: '1rem', resize: 'vertical' }
};

export default Contact;